import { render } from "./TrainingSectionGridBlocks.vue?vue&type=template&id=4d3b87a3&scoped=true"
import script from "./TrainingSectionGridBlocks.vue?vue&type=script&lang=js"
export * from "./TrainingSectionGridBlocks.vue?vue&type=script&lang=js"

import "./TrainingSectionGridBlocks.vue?vue&type=style&index=0&id=4d3b87a3&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3b87a3"]])

export default __exports__